module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA3ElEQVRYhe2SMQrCMBSG/zatS1GHTlkK3kbwBK6CeCWhruLgLHgIL2FvIMWl2MZBAlJIICUvb8k/JfDg/3jvSx7PowBjUs7yCBABACALXXjpNstWFRUAzJN3ExygVUWlgFy/g59Al+s3uwMRgETCsenb2e1lmiXZgDZdAbkGCQowNj04gEvYASZL6CKaLZM34CIaCYCLaCQAvsIOYJXQl2i2WDfgS7TJAL5EsyU7XXfrzyKpVTkgLbv9YXW+UxSZkvaDqAFIALJXog5ZDvxOIP/+0jRICcCaCMAO8AUMNk86GEc+KwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/NB/second_signal_1.png
// module id = AjIZ
// module chunks = 1